/**
 * Test IDs for QA automation.
 */
export const testIds = {
  viewCustomerDetails: "view-customer-details",
  viewCustomerBilling: "view-customer-billing",
  viewCustomerRating: "view-customer-rating",
  viewCustomerOpenNationalFuelRateTable: "view-customer-open-national-fuel-rate-table",
} as const;
